// ############################################################################
// ## FORM VALIDATION #########################################################
// ############################################################################

import $ from "jquery"
import {AJAX} from "./ajax";

$.fn.validate = function() {
  var valid = true;

  this.each(function() {
    if (this.checkValidity() === false) {
      $(this).addClass('was-validated');
      valid = false;
    }
  });

  return valid;
};

$.fn.validateOnSubmit = function() {
  this.each(function() {
    var $form = $(this);
    if($form.data("validation_bound")) return;
    $form.data("validation_bound", true);
    $form.on('submit', function($evt) {
      if ($form.validate() === false) {
        $evt.preventDefault();
        $evt.stopPropagation();
      }
    });
  });
};

function bindValidation() {
  $('.needs-validation').validateOnSubmit();
}

$(bindValidation);
AJAX.onUpdate(bindValidation);
